module.exports = __webpack_public_path__ + "static/hublot-cc8d42f9d34762fcb920d2b385990fe5.png";